<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
@if ((openedMobileMenu$ | async) === 'main') {
  <div class="w-full flex flex-col items-center p-4 pb-20" [@fadeOut]>
    <span class="mt-2 mb-4 text-xxs tracking-widest">MENU</span>
    <ul class="w-full">
      <li class="ss-mobile-nav-item">
        <button
          aria-haspopup="true"
          (click)="dispatchSetMobileMenu('liveShows')"
          class="flex flex-row items-center pt-4 pb-3 uppercase gap-4"
        >
          <span>Live Shows</span
          ><img
            src="/assets/icons/right-arrow-icon.svg"
            class="w-8 lg:hidden"
            alt="live shows"
          />
        </button>
      </li>
      @if (shellState$ | async; as shellState) {
        <li class="ss-mobile-nav-item">
          <a
            (click)="closeMobileMenu()"
            class="flex flex-row pt-4 pb-3"
            [routerLink]="[shellState.headerContent?.filmsPage?.url]"
            >Feature Films</a
          >
        </li>
        <li class="ss-mobile-nav-item">
          <a
            (click)="closeMobileMenu()"
            class="flex flex-row pt-4 pb-3"
            [routerLink]="[shellState.headerContent?.tvPage?.url]"
            >Streaming</a
          >
        </li>
      }
      <li class="ss-mobile-nav-item">
        <button
          aria-haspopup="true"
          class="flex flex-row items-center pt-4 pb-3 uppercase gap-4"
          (click)="dispatchSetMobileMenu('more')"
        >
          <span>More</span
          ><img
            src="/assets/icons/right-arrow-icon.svg"
            class="w-8 lg:hidden"
            alt="live shows"
          />
        </button>
      </li>
    </ul>
    <ss-button
      (click)="closeMobileMenu()"
      class="w-full mt-6"
      buttonColor="principal"
      buttonStyle="filled"
      routerLink="/ticketing"
      >GET TICKETS</ss-button
    >
    @if (headerContent$ | async; as headerContent) {
      @if (headerContent.mobilePromoBlockTitle) {
        <div class="text-center mt-10">
          <div
            class="mb-1 md:text-xl max-md:leading-7 tracking-[0.54px] md:tracking-[0.72px] font-campan uppercase font-medium text-base"
          >
            {{ headerContent.mobilePromoBlockTitle }}
          </div>
        </div>
      }
      @if (headerContent.mobilePromoBlockImage) {
        <img
          [ngSrc]="headerContent.mobilePromoBlockImage.id"
          [loaderParams]="{
            modifiedDate: headerContent.mobilePromoBlockImage.modified_on,
          }"
          alt="Promotional Image"
          width="500"
          height="200"
        />
      }
      @if (headerContent.mobilePromoBlockUrl?.startsWith('/')) {
        <a
          [routerLink]="[headerContent.mobilePromoBlockPage?.url]"
          class="w-full no-underline"
        >
          <ng-container *ngTemplateOutlet="promoButton"></ng-container>
        </a>
      } @else {
        <a
          [href]="headerContent.mobilePromoBlockUrl"
          class="w-full no-underline"
        >
          <ng-container *ngTemplateOutlet="promoButton"></ng-container>
        </a>
      }
      <ng-template #promoButton>
        @if (
          headerContent.mobilePromoBlockButtonText &&
          (headerContent.mobilePromoBlockPage ||
            headerContent.mobilePromoBlockUrl)
        ) {
          <ss-button
            class="w-full m-4"
            buttonColor="accent"
            buttonStyle="filled"
            (click)="dispatchPromoLinkClicked()"
            >{{ headerContent.mobilePromoBlockButtonText }}</ss-button
          >
        }
      </ng-template>
    }
  </div>
}
@if ((openedMobileMenu$ | async) === 'liveShows') {
  <div class="w-full h-full p-4 overflow-auto" [@enterAnimationSide]>
    <ng-container *ngTemplateOutlet="backButton"></ng-container>
    <div class="w-full flex flex-col items-center">
      <span class="p-4 text-2xl font-campan tracking-[0.06rem] font-medium"
        >LIVE SHOWS</span
      >
      <hr class="ss-divider" />
      @if (shows$ | async; as shows) {
        <ss-www-theater-shows-list
          class="w-full"
          theaterName="LANCASTER, PA"
          theater="lancaster"
        >
        </ss-www-theater-shows-list>
        <ss-www-theater-shows-list
          class="w-full mb-8"
          theaterName="BRANSON, MO"
          theater="branson"
        >
        </ss-www-theater-shows-list>
      }
    </div>
  </div>
}
@if ((openedMobileMenu$ | async) === 'more') {
  <div class="w-full p-4" [@enterAnimationSide]>
    <ng-container *ngTemplateOutlet="backButton"></ng-container>
    <div
      class="text-center text-2xl md:text-3xl mb-2 font-medium font-campan tracking-[0.04rem] py-4 border-b-2 border-black"
    >
      MORE
    </div>
    @if (bigImageLinks$ | async; as bigImageLinks) {
      <div class="grid grid-cols-2 mb-20 gap-4 mt-4">
        @for (
          link of bigImageLinks;
          track trackBigImageLink(i, link);
          let i = $index
        ) {
          <ss-www-big-image-link
            class="block"
            [ngClass]="{
              'col-span-2': i < 2,
            }"
            [image]="link.image"
            [titleText]="link.text"
            [url]="link.page?.url ?? link.url ?? '#'"
            heightClass="h-36"
            [desktopImageSize]="'2/3rds'"
          />
        }
      </div>
    }
  </div>
}

<ng-template #backButton>
  <button
    class="flex flex-row items-center mt-2"
    (click)="dispatchSetMobileMenu('main')"
  >
    <img
      src="/assets/icons/left-arrow-icon.svg"
      class="w-5 lg:hidden"
      alt="live shows"
    /><span class="ml-2 text-xxs font-light tracking-wider"
      >BACK TO MAIN MENU</span
    >
  </button>
</ng-template>
